// Studyo Today Backend
// Package studyo.today.users.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/users/v1/resources/identity_provider.proto (package studyo.today.users.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/users/v1/resources/identity_provider.proto.
 */
export const file_studyo_today_users_v1_resources_identity_provider = /*@__PURE__*/
  fileDesc("CjdzdHVkeW8vdG9kYXkvdXNlcnMvdjEvcmVzb3VyY2VzL2lkZW50aXR5X3Byb3ZpZGVyLnByb3RvEh9zdHVkeW8udG9kYXkudXNlcnMudjEucmVzb3VyY2VzKq4BChBJZGVudGl0eVByb3ZpZGVyEiEKHUlERU5USVRZX1BST1ZJREVSX1VOU1BFQ0lGSUVEEAASHAoYSURFTlRJVFlfUFJPVklERVJfR09PR0xFEAESHwobSURFTlRJVFlfUFJPVklERVJfTUlDUk9TT0ZUEAISGwoXSURFTlRJVFlfUFJPVklERVJfQVBQTEUQAxIbChdJREVOVElUWV9QUk9WSURFUl9FTUFJTBAEQieqAiRTdHVkeW8uVG9kYXkuVXNlcnMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw");

/**
 * Describes the enum studyo.today.users.v1.resources.IdentityProvider.
 */
export const IdentityProviderSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_users_v1_resources_identity_provider, 0);

/**
 * Represents supported external identity providers for Today.
 *
 * @generated from enum studyo.today.users.v1.resources.IdentityProvider
 */
export const IdentityProvider = /*@__PURE__*/
  tsEnum(IdentityProviderSchema);

